import { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { SEO } from '@/components/SEO/SEO'
import { usePricingPlans } from '@/hooks/usePricingPlans'
import { LandingV3Experience } from './LandingV3Experience'
import { resolveLandingV3Content } from './landingV3Content'
import './LandingV3.css'

export function LandingPage() {
  const { hash } = useLocation()
  const { marketingCopy } = usePricingPlans()
  const content = useMemo(() => resolveLandingV3Content(marketingCopy), [marketingCopy])

  useEffect(() => {
    if (!hash) return
    const target = document.querySelector(hash)
    target?.scrollIntoView({ behavior: 'smooth' })
  }, [hash])

  return (
    <div id="main-content" role="region" aria-label="Ricald commercial operating layer">
      <SEO
        title={content.seo.title}
        description={content.seo.description}
      />
      <LandingV3Experience content={content} />
    </div>
  )
}

export default LandingPage
